import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';

import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

export const theses = [
    {
        authors : "Travis Desell",
        title : "Asynchronous Global Optimization for Massive-Scale Computing",
        venue : "PhD Thesis",
        location : "Rensselaer Polytechnic Institute",
        date : "December 2009",
        pdf : "http://wcl.cs.rpi.edu/theses/desell-phd-thesis.pdf"
    },
    {

        authors : "Travis Desell",
        title : "Autonomic Grid Computing using Malleability and Migration: An Actor-Oriented Software Framework",
        venue : "Master's Thesis",
        location : "Rensselaer Polytechnic Institute",
        date : "May 2007",
        pdf : "http://wcl.cs.rpi.edu/theses/desell_masters.pdf"
    }
];
//End Theses Section


export const books =
    [
        {
            authors : "Sima Noghanian, Abas Sabouni, Travis Desell and Ali Ashtari",
            title : "Microwave Tomography - Global Optimization, Parallelization and Performance Evaluation",
            publisher : "Springer",
            date : "2014",
            html : "http://www.springer.com/engineering/electronics/book/978-1-4939-0751-9"
        }
    ];
//End Books section

export const bookChapters =
    [
        {
            authors : "Travis Desell, AbdElRahman ElSaid and Alexander G. Ororbia II",
            title : "Investigating Deep Recurrent Connections and Recurrent Memory Cells Using Neuro-Evolution",
            venue : "In H. Iba and N. Noman: Deep Neural Evolution – Deep Learning with Evolutionary Computation",
            pages : "36 pages",
            publisher : "Springer",
            date : "2020"
        },

        {
            authors : "Nathan Cole, Travis Desell, Daniel Lombranaa Gonzalez, Francisco Fernandez de Vega, Malik Magdon-Ismail, Heidi Newberg, Boleslaw Szymanski and Carlos A. Varela",
            title : "Evolutionary Algorithms on Volunteer Computing Platforms: The MilkyWay@Home Project",
            venue : "In F. Fernandez de Vega, E. Cantu-Paz (Eds.): Parallel and Distributed Computational Intelligence",
            pages : "SCI 269, pages 63-90",
            publisher : "Springer-Verlag Berlin Heidelberg",
            date : "2010",
            pdf : "http://wcl.cs.rpi.edu/papers/2010_pci.pdf"
        },

        {
            authors : "Kaoutar El Maghraoui, Travis Desell, Boleslaw K. Szymanski, James D. Teresco, and Carlos A. Varela",
            title : "Towards a Middleware Framework for Dynamically Reconfigurable Scientific Computing",
            venue : "In L. Grandinetti, editor, Grid Computing and New Frontiers of High Performance Processing",
            pages : "Advances in Parallel Computing, Volume 14, pages 275-301",
            publisher : "Elsevier",
            date : "2005",
            pdf : "http://www.cs.rpi.edu/~elmagk/papers/elmagk05.pdf"
        }
    ]
//End Book Chapters Section

export const preprints = [
    {
        authors : "Hong Yang, Aidan LaBella and Travis Desell",
        title : "Predictive Maintenance for General Aviation Using Convolutional Transformers",
        venue : "arXiv: Machine Learning (cs.LG)",
        pdf : "https://arxiv.org/abs/2110.03757",
        date : "October, 2021"
    },

    {
        authors : "Zimeng Lyu, AbdElRahman ElSaid, Joshua Karns, Alexander Ororbia and Travis Desell",
        title : "Continuous Ant-Based Neural Topology Search",
        venue : "arXiv: Computation and Language (cs.CL)",
        pdf : "https://arxiv.org/abs/2011.10831",
        date : "November, 2020"
    },


    {
        authors : "Zimeng Lyu, AbdElRahman ElSaid, Joshua Karns, Mohamed Mkaouer and Travis Desell",
        title : "A Experimental Study of Weight Initialization and Weight Inheritance Effects on Neuroevolution",
        venue : "arXiv: Computation and Language (cs.CL)",
        pdf : "https://arxiv.org/abs/2009.09644",
        date : "September, 2020"
    },


    {
        authors : "Farhad Akhbardeh, Travis Desell and  Marcos Zampieri",
        title : "MaintNet: A Collaborative Open-Source Library for Predictive Maintenance Language Resources",
        venue : "arXiv: Computation and Language (cs.CL)",
        pdf : "https://arxiv.org/abs/2005.12443",
        date : "May, 2020"
    },

    {
        authors : "Zimeng Lyu, Joshua Karns, AbdElRahman ElSaid and Travis Desell",
        title : "Improving Neuroevolution Using Island Extinction and Repopulation",
        venue : "arXiv: Neural and Evolutionary Computing (cs.NE)",
        pdf : "https://arxiv.org/abs/2005.07376",
        date : "May, 2020"
    },

    {
        authors : "AbdElRahman ElSaid, Alexander G. Ororbia and Travis Desell",
        title : "The Ant Swarm Neuro-Evolution Procedure for Optimizing Recurrent Networks",
        venue : "arXiv: Neural and Evolutionary Computing (cs.NE)",
        pdf : "https://arxiv.org/abs/1909.11849",
        date : "September, 2019"
    },

    {
        authors : "Travis Desell, AbdElRahman ElSaid and Alexander G. Ororbia",
        title : "An Empirical Exploration of Deep Recurrent Connections and Memory Cells Using Neuro-Evolution",
        venue : "arXiv: Neural and Evolutionary Computing (cs.NE)",
        pdf : "https://arxiv.org/abs/1909.09502",
        date : "September, 2019"
    },

    {
        authors : "Alex Ororbia, AbdElRahman ElSaid and Travis Desell",
        title : "Investigating Recurrent Neural Network Memory Structures using Neuro-Evolution",
        venue : "arXiv: Neural and Evolutionary Computing (cs.NE)",
        pdf : "https://arxiv.org/abs/1902.02390",
        date : "February, 2019"
    },

    {
        authors : "Travis Desell",
        title : "Accelerating the Evolution of Convolutional Neural Networks with Node-Level Mutations and Epigenetic Weight Initialization",
        venue : "arXiv: Neural and Evolutionary Computing (cs.NE)",
        pdf : "https://arxiv.org/abs/1811.08286",
        date : "November, 2018"
    },

    {
        authors : "AbdElRahman ElSaid, Travis Desell, Fatima El Jamiy, James Higgins and Brandon Wild",
        title : "Optimizing Long Short-Term Memory Recurrent Neural Networks Using Ant Colony Optimization to Predict Turbine Engine Vibration",
        venue : "arXiv: Neural and Evolutionary Computing (cs.NE)",
        pdf : "https://arxiv.org/abs/1710.03753",
        date : "October 10, 2017"
    },

    {
        authors : "Travis Desell",
        pdf : "https://arxiv.org/abs/1703.05422",
        title : "Large Scale Evolution of Convolutional Neural Networks Using Volunteer Computing",
        venue : "arXiv: Neural and Evolutionary Computing (cs.NE)",
        date : "March 15, 2017"
    }
];
//End Preprint Section



export const journals = [
    {
        authors: "AbdElRahman ElSaid, Karl Ricanek, Zimeng Lyu, Alexander Ororbia and Travis Desell",
        title: "Backpropagation-free 4D continuous ant-based neural topology search",
        venue: "Applied Soft Computing",
        pdf: "https://www.sciencedirect.com/science/article/abs/pii/S156849462300755X",
        date: "August, 2023",
    },
    {
        authors: "Zimeng Lyu, Alexander Ororbia and Travis Desell",
        title: "Online Evolutionary Neural Architecture Search for Multivariate Non-Stationary Time Series Forecasting",
        venue: "Applied Soft Computing",
        pdf: "https://www.sciencedirect.com/science/article/pii/S1568494623005409",
        date: "June, 2023",
    },
    {
        authors: "Javier Lenzi, Andrew Barnas, AbdElRahman ElSaid, Travis Desell, Robert Rockwell and Susan Ellis-Felege",
        title: "Artificial Intelligence for Automated Detection of Large Mammals Creates Path to Upscale Drone Surveys",
        venue: "Scientific Reports",
        pdf: "https://www.nature.com/articles/s41598-023-28240-9",
        date: "January, 2023"
    },

    {
        authors : "Deema Alshoaibi, Mohamed Wiem Mkaouer, Ali Ouni, AbdulMutalib Wahaishi, Travis Desell and Makram Soui",
        title : "Search-based Detection of Code Changes Introducing Performance Regression",
        venue : "Swarm and Evolutionary Computation",
        pdf : "https://www.sciencedirect.com/science/article/abs/pii/S2210650222000712",
        date : "August, 2022"
    },

    {
        authors : "Aaron Bergstrom, John Nowatzki, Trevor Witt, Isaac Barnhart, Jordan Krueger, Mark Askelson, Kurt Barnhart, and Travis Desell",
        title : "Protecting Farm Privacy while Researching Large-Scale UAS Platforms for Agricultural Applications",
        venue : "Agronomy Journal",
        pdf : "https://acsess.onlinelibrary.wiley.com/doi/10.1002/agj2.21054",
        date : "March, 2022"
    },

    {
        authors : "Travis Desell, AbdElRahman ElSaid, Zimeng Lyu, David Stadem, Shuchita Patwardhan and Steve Benson",
        title : "Long Term Predictions of Coal Fired Power Plant Data Using Evolved Recurrent Neural Networks",
        venue : "at - Automatisierungstechnik",
        pages : "Volume 68: No 2, Pages 130-139",
        pdf : "https://doi.org/10.1515/auto-2019-0116",
        date : "January, 2020"
    },

    {
        authors : "Connor Bowley, Marshall Mattingly, Andrew Barnas, Susan Ellis-Felege and Travis Desell",
        title : "An Analysis of Altitude, Citizen Science and a Convolutional Neural Network Feedback Loop on Object Detection in Unmanned Aerial Systems",
        venue : "Journal of Computational Science",
        pdf : "https://www.sciencedirect.com/science/article/pii/S1877750318310287",
        date : "May, 2019"
    },

    {
        authors : "Jake Weiss, Heidi Jo Newberg, Matthew Newby, and Travis Desell",
        title : "Fitting the Density Substructure of the Stellar Halo with MilkyWay@Home",
        venue : "The Astrophysical Journal Supplement Series, Volume 238, Number 2",
        pdf : "http://iopscience.iop.org/article/10.3847/1538-4365/aadb92/meta",
        date : "September, 2018"
    },

    {
        authors : "AbdElRahman ElSaid, Travis Desell, Fatima El Jamiy, James Higgins and Brandon Wild",
        title : "Optimizing Long Short-Term Memory Recurrent Neural Networks Using Ant Colony Optimization to Predict Turbine Engine Vibration",
        venue : "Applied Soft Computing",
        pdf : "https://www.sciencedirect.com/science/article/pii/S1568494618305301",
        pages : "Volume 73, Pages 969-991",
        date : "December, 2018"
    },

    {
        authors : "Andrei P. Kirilenko, Travis Desell, Hany Kim, and  Svetlana Stepchenkova",
        pdf : "http://www.mdpi.com/2071-1050/9/11/2019",
        title : "Crowdsourcing Analysis of Twitter Data on Climate Change: Paid Workers vs. Volunteers",
        venue : "Sustainability",
        date : "November 3, 2017"
    },

    {
        authors : "Susan N. Ellis-Felege, Travis Desell and Christopher J. Felege",
        pdf : "http://volunteer.cs.und.edu/wildlife/publications/birds_eye_view.pdf",
        title : "A Bird's Eye View of... Birds: Combining Technology and Citizen Science for Conservation",
        venue : "Wildlife Professional 8: 27-30",
        date : "Spring 2014",
        note : "PDF courtsey of The Wildlife Professional"
    },

    {
        authors : "Travis Desell and Carlos Varela",
        pdf : "./papers/2013_cob.pdf",
        title : "SALSA Lite: A Hash-Based Actor Runtime for Efficient Local Concurrency",
        venue : "Springer Lecture Notes in Computer Science: Concurrent Objects and Beyond",
        pages : "23 pages",
        date : "2013",
    },

    {
        authors : "Matthew Newby, Nathan Cole, Heidi Jo Newberg, Travis Desell, Malik Magdon-Ismail, Boleslaw Szymanski, Carlos Varela, Benjamin Willett, and Brian Yanny",
        pdf : "http://iopscience.iop.org/1538-3881/145/6/163/",
        title : "A Spatial Characterization of the Sagittarius Dwarf Galaxy Tidal Tails",
        venue : "The Astronomical Journal",
        pages : "Volume 145, Number 6",
        date : "May 2013"
    },

    {
        authors : "Travis Desell, Jason LaPorte, Carlos A. Varela, and Gustavo Guevara",
        pdf : "http://www.clei.cl/cleiej/paper.php?id=213",
        title : "Modular Visualization of Distributed Systems",
        venue : "CLEI (Latin-american Center for Informatics Studies) Electronic Journal: Special issue of best papers presented at CLEI'2010",
        pages : "Volume 14, Number 1, Paper 7",
        date : "April 2011"
    },

    {
        authors : "Kaoutar El Maghraoui, Travis Desell, Boleslaw K. Szymanski, and Carlos A. Varela",
        pdf : "http://wcl.cs.rpi.edu/papers/elmaghraoui-malleability-ccpe-2008.pdf",
        title : "Malleable Iterative MPI Applications",
        venue : "Concurrency and Computation: Practice and Experience",
        pages : "Volume 21, Issue 3, pages 393-413",
        date : "March 2009"
    },

    {
        authors : "Nathan Cole, Heidi Newberg, Malik Magdon-Ismail, Travis Desell, Kristopher Dawsey, Warren Hayashi, Jonathan Purnell, Boleslaw Szymanski, Carlos A. Varela, Benjamin Willett, and James Wisniewski",
        pdf : "http://wcl.cs.rpi.edu/papers/cole-apj-2008.pdf",
        title : "Maximum Likelihood Fitting of Tidal Streams with Application to the Sagittarius Dwarf Tidal Tails",
        venue : "Astrophysical Journal",
        pages : "Volume 683, pages 750-766",
        date : "2008"
    },

    {
        authors : "Travis Desell, Kaoutar El Maghraoui, and Carlos A. Varela",
        pdf : "http://wcl.cs.rpi.edu/papers/cc-malleability2007.pdf",
        title : "Malleable Applications for Scalable High Performance Computing",
        venue : "Cluster Computing",
        pages : "pages 323-337",
        date : "June 2007"
    },

    {
        authors : "Kaoutar El Maghraoui, Travis Desell, Boleslaw K. Szymanski, and Carlos A. Varela",
        pdf : "http://wcl.cs.rpi.edu/papers/ijhpca06.pdf",
        title : "The Internet Operating System: Middleware for Adaptive Distributed Computing",
        venue : "The International Journal of High Performance Computing Applications (IJHPCA): Special Issue on Scheduling Techniques for Large-Scale Distributed Platforms",
        pages : "Volume 20, Issue 4, pages 467-480",
        date : "2006"
    }
];
//end journal article section


export const conferencePapers = [
    {
        authors: "Aditya Shankar Thakur, Akshar Bajrang Awari, Zimeng Lyu, and Travis Desell",
        title: "Efficient Neuroevolution using Island Repopulation and Simplex Hyperparameter Optimization",
        venue: "The 2023 IEEE Symposium Series on Computational Intelligence (SSCI 2023)",
        date: "December 5-8, 2023",
        location: "Mexico City, Mexico",
        pdf: "./papers/2023_ssci_island_sho.pdf",
    },
    {
        authors: "Amit Dilip Kini∗, Swaraj Sambhaji Yadav∗, Aditya Shankar Thakur, Akshar Bajrang Awari, Zimeng Lyu, and Travis Desell",
        title: "Co-evolving Recurrent Neural Networks and their Hyperparameters with Simplex Hyperparameter Optimization",
        venue: "The Genetic and Evolutionary Computation Conference Companion (GECCO ’23 Companion)",
        date: "July 15–19, 2023",
        location: "Lisbon, Portugal",
        pdf: "./papers/2023_gecco_sho.pdf",
        note : "*Indicates equal contribution"
    },
    {
        authors: "Joshua Karns and Travis Desell",
        title: "Local Stochastic Differentiable Architecture Search for Memetic Neuroevolution Algorithms",
        venue: "The Genetic and Evolutionary Computation Conference Companion (GECCO ’23 Companion)",
        date: "July 15–19, 2023",
        location: "Lisbon, Portugal",
        pdf: "./papers/2023_gecco_darts.pdf"
    },
    {
        authors : "Aizaz Ul Haq, Niranjana Deshpande, AbdElRahman ElSaid, Travis Desell and Daniel Krutz",
        title : "Addressing Tactic Volatility in Self-Adaptive Systems Using Evolved Recurrent Neural Networks and Uncertainty Reduction Tactics",
        venue : "The Genetic and Evolutionary Computation Conference (GECCO 2022)",
        location : "Boston, USA",
        date : "July 9-13, 2022",
        pdf : "./papers/2022_gecco_tactics.pdf"
    },

    {
        authors : "Zimeng Lyu and Travis Desell",
        title : "ONE-NAS: An Online NeuroEvolution based Neural Architecture Search for Time Series Forecasting",
        venue : "The Genetic and Evolutionary Computation Conference (GECCO 2022)",
        location : "Boston, USA",
        date : "July 9-13, 2022",
        pdf : "./papers/2022_gecco_onenas.pdf"
    },

    {
        authors : "Aidan LaBella, Joshua Karns, Farhad Akhbardeh, Andrew Walton, Zechariah Morgan, Brandon Wild, Mark Dusenbury and Travis Desell",
        title : "Optimized Flight Safety Event Detection in the National General Aviation Flight Information Database",
        venue : "In The 37th ACM/SIGAPP Symposium on Applied Computing (SAC '22)",
        location : "Online",
        date : "April 25-29, 2022",
        pdf : "./papers/2022_sac_ngafid.pdf"
    },

    {
        authors : "Michael Kogan, Joshua Karns and Travis Desell",
        title : "Self-Adaptation of Neuroevolution Algorithms using Reinforcement Learning",
        venue : "The 25th International Conference on the Applications of Evolutionary Computation (EvoStar: EvoApps 2021)",
        location : "Madrid, Spain",
        date : "April 20-22, 2022",
        pdf : "./papers/2022_evostar_fala.pdf"
    },


    {
        authors : "Hong Yang, Aidan LaBella and Travis Desell",
        title : "Predictive Maintenance for General Aviation Using Convolutional Transformers",
        venue : "The Thirty-Fourth Annual Conference on Innovative Applications of Artificial Intelligence (IAAI-22)",
        location : "Vancouver, British Columbia, Canada",
        date : "February 24 - 26, 2022",
        pdf : "./papers/2022_iaai_maintenance.pdf"
    },

    {
        authors : "Hitesh Vaidya, Travis Desell* and Alexander Ororbia*",
        title : "Reducing Catastrophic Forgetting in Self Organizing Maps with Internally-Induced Generative Replay (Student Abstract)",
        venue : "The 36th AAAI Conference on Artificial Intelligence (AAAI 2022)",
        location : "Vancouver, British Columbia, Canada",
        date : "February 22 - March 1, 2022",
        pdf : "./papers/2022_aaai_soms_forgetting.pdf"
    },

    {
        authors : "Farhad Akhbardeh, Cecilia Ovesdotter Alm, Marcos Zampieri and Travis Desell",
        title : "Handling Extreme Class Imbalance in Technical Logbook Datasets",
        venue : "In Proceedings of the 59th Annual Meeting of the Association for Computational Linguistics and the 11th International Joint Conference on Natural Language Processing (ACL-IJCNLP 2021)",
        location : "Bangkok, Thailand",
        date : "August 2-4, 2021",
        pdf : "./papers/2021_acl_feedback_loop.pdf"
    },

    {
        authors : "Zimeng Lyu, Shuchita Patwardhan, David Stadem, James Langfeld, Steve Benson, and Travis Desell",
        title : "Neuroevolution of Recurrent Neural Networks for Time Series Forecasting of Coal-Fired Power Plant Data",
        venue : "ACM Workshop on NeuroEvolution@Work (NEWK@Work}, held in conjunction with ACM Genetic and Evolutionary Computation Conference (GECCO)",
        pages : "pp. 1735-1743",
        location : "Lille, France",
        date : "July 10-14, 2021",
        pdf : "./papers/2021_Gecco_NEWK_Work_Workshop_Zimeng.pdf"
    },

    {
        authors : "Joshua Karns and Travis Desell",
        title : "Improving the Scalability of Distributed Neuroevolution Using Modular Congruence Class Generated Innovation Numbers",
        venue : "The 1st Workshop on Evolutionary Algorithms and High Performance Computing (EAHPC), held in conjunction with ACM Genetic and Evolutionary Computation Conference (GECCO)",
        location : "Lille, France",
        date : "July 10-14, 2021",
        pdf : "./papers/2021_gecco_eahpc_congruence.pdf"
    },

    {
        authors : "AbdElRahman ElSaid, Joshua Karns, Zimeng Lyu, Alexander Ororbia and Travis Desell",
        title : "Continuous Ant-Based Neural Topology Search",
        venue : "The 24th International Conference on the Applications of Evolutionary Computation (EvoStar: EvoApps 2021)",
        location : "Online",
        date : "April 7-9, 2021",
        pdf : "./papers/2021_evostar_cants.pdf"
    },

    {
        authors : "Zimeng Lyu, AbdElRahman ElSaid, Joshua Karns, Mohamed Mkaouer and Travis Desell",
        title : "An Experimental Study of Weight Initialization and Lamarckian Inheritance on Neuroevolution",
        pages : "pp. 584-600",
        venue : "The 24th International Conference on the Applications of Evolutionary Computation (EvoStar: EvoApps 2021)",
        location : "Online",
        date : "April 7-9, 2021",
        pdf : "./papers/2021_EvoStar_Weight_initialization.pdf"
    },

    {
        authors : "Zimeng Lyu, AbdElRahman ElSaid, Joshua Karns, Mohamed Mkaouer and Travis Desell",
        title : "Improving Distributed Neuroevolution Using Island Extinction and Repopulation",
        venue : "The 24th International Conference on the Applications of Evolutionary Computation (EvoStar: EvoApps 2021)",
        pages : "pp. 568-583",
        location : "Online",
        date : "April 7-9, 2021",
        pdf : "./papers/2021_EvoStar_Repopulation.pdf"
    },

    {
        authors : "Farhad Akhbardeh, Travis Desell, and Marcos Zampieri",
        title : "NLP Tools for Predictive Maintenance Records in MaintNet",
        venue : "In Proceedings of the 1st Conference of the Asia-Pacific Chapter of the Association for Computational Linguistics and the 10th International Joint Conference on Natural Language Processing: System Demonstrations",
        location : "Suzhou, China",
        date : "December, 2020",
        pdf : "https://www.aclweb.org/anthology/2020.aacl-demo.5/"
    },

    {
        authors : "Farhad Akhbardeh, Travis Desell, and Marcos Zampieri",
        title : "MaintNet: A Collaborative Open-Source Library for Predictive Maintenance Language Resources",
        venue : "In Proceedings of the 28th International Conference on Computational Linguistics: System Demonstrations",
        location : "Barcelona, Spain",
        date : "December, 2020",
        pdf : "https://www.aclweb.org/anthology/2020.coling-demos.2/"
    },

    {
        authors : "AbdElRahman ElSaid, Joshua Karns, Zimeng Lyu, Daniel Krutz, Alexander Ororbia and Travis Desell",
        title : "Improving Neuroevolutionary Transfer Learning of Deep Recurrent Neural Networks through Network-Aware Adaptation",
        venue : "The Genetic and Evolutionary Computation Conference (GECCO 2020)",
        location : "Cancun, Mexico",
        date : "July 8-12, 2020",
        pdf : "./papers/2020_gecco_transfer.pdf",
        note : "Best paper nominee"
    },

    {
        authors : "Ryne Roady, Tyler L. Hayes, Hitesh Vaidya, Christopher Kanan",
        title : "Stream-51: Streaming Classification and Novelty Detection From Videos",
        venue : "In Proceedings of the IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) Workshops",
        pages : "228-229",
        date : "June 14-19, 2020",
        pdf : "https://openaccess.thecvf.com/content_CVPRW_2020/papers/w15/Roady_Stream-51_Streaming_C[…]ion_and_Novelty_Detection_From_Videos_CVPRW_2020_paper.pdf",
        not_mine : true /***** NOT ONE OF MINE*****/
    },

    {
        authors : "Travis Desell, AbdElRahman ElSaid and Alexander G. Ororbia",
        title : "An Empirical Exploration of Deep Recurrent Connections Using Neuro-Evolution",
        venue : "The 23nd International Conference on the Applications of Evolutionary Computation (EvoStar: EvoApps 2020)",
        location : "Seville, Spain",
        date : "April 15-17, 2020",
        pdf : "./papers/2020_evostar_deep_recurrent.pdf",
        note : "Best paper nominee"
    },

    {
        authors : "AbdElRahman ElSaid, Joshua Karns, Zimeng Lyu, Daniel Krutz, Alexander G. Ororbia and Travis Desell",
        title : "Neuro-Evolutionary Transfer Learning through Structural Adaptation",
        venue : "The 23nd International Conference on the Applications of Evolutionary Computation (EvoStar: EvoApps 2020)",
        location : "Seville, Spain",
        date : "April 15-17, 2020",
        pdf : "./papers/2020_evostar_transfer.pdf"
    },

    {
        authors : "AbdElRahman ElSaid, Alexander G. Ororbia* and Travis Desell*",
        title : "Ant-based Neural Topology Search (ANTS) for Optimizing Recurrent Networks",
        venue : "The 23nd International Conference on the Applications of Evolutionary Computation (EvoStar: EvoApps 2020)",
        location : "Seville, Spain",
        date : "April 15-17, 2020",
        pdf : "./papers/2020_evostar_ants.pdf",
        note : "*Indicates equal advising"
    },

    {
        authors : "Jeffery Palmerino, Qi Yu, Travis Desell and Daniel Krutz",
        title : "Improving the Decision-Making Process of Self-Adaptive Systems by Accounting for Tactic Volatility",
        venue : "The 34th IEEE/ACM International Conference on Automated Software Engineering (ASE 2019)",
        location : "San Diego, California, USA", 
        pages : "949-961",
        date : "November 10-15, 2019",
        pdf : "./papers/TVA_ASE_2019.pdf"
    },

    {
        authors : "Alex Ororbia, AbdElRahman ElSaid, and Travis Desell",
        title : "Investigating Recurrent Neural Network Memory Structures using Neuro-Evolution",
        venue : "The Genetic and Evolutionary Computation Conference (GECCO 2019)",
        location : "Prague, Czech Republic",
        date : "July 8-12, 2019",
        pdf : "./papers/2019_gecco_examm.pdf"
    },

    {
        authors : "AbdElRahman ElSaid, Steven Benson, Shuchita Patwardhan, David Stadem and Travis Desell",
        title : "Evolving Recurrent Neural Networks for Time Series Data Prediction of Coal Plant Parameters",
        venue : "The 22nd International Conference on the Applications of Evolutionary Computation  (EvoStar: EvoApps 2019)",
        location : "Leipzig, Germany",
        date : "April 24-26, 2019",
        pdf : "./papers/2019_evostar_exalt.pdf"
    },

    {
        authors : "AbdElRahman ElSaid, Travis Desell and Daniel Krutz",
        title : "Is Adaptivity a Core Property of Intelligent Systems? It Depends",
        venue : "The 2019 IEEE/ACM 14th International Symposium on Software Engineering for Adaptive and Self-Managing Systems (SEAMS)",
        location : "Montreal, Canada",
        date : "May 25-26, 2019",
        pdf : "https://ieeexplore.ieee.org/abstract/document/8787199"
    },

    {
        authors : "Kelton Karboviak, Sophine Clachar, Travis Desell, Mark Dusenbury, Wyatt Hedrick, James Higgins, John Walberg, and Brandon Wild",
        title : "Classifying Aircraft Approach Type in the National General Aviation Flight Information Database",
        venue : "The 2018 International Conference on Computational Science (ICCS 2018)",
        location : "Wuxi, China",
        date : "June 11th-13th, 2018",
        pdf : "./papers/2018_iccs_aircraft.pdf"
    },

    {
        authors : "Connor Bowley, Marshall Mattingly, Andrew Barnas, Susan Ellis-Felege and Travis Desell",
        title : "Detecting Wildlife in Unmanned Aerial Systems Imagery using Convolutional Neural Networks Trained with an Automated Feedback Loop",
        venue : "The 2018 International Conference on Computational Science (ICCS 2018)",
        location : "Wuxi, China",
        date : "June 11th-13th 2018",
        pdf : "./papers/2018_iccs_cnn_wildlife.pdf"
    },

    {
        authors : "AbdElRahman ElSaid, Fatima El Jamiy, James Higgins, Brandon Wild and Travis Desell ",
        title : "Using Ant Colony Optimization to Optimize Long Short-Term Memory Recurrent Neural Networks",
        venue : "The 2018 Genetic and Evolutionary Computation Conference (GECCO 2018)",
        location : "Kyoto, Japan",
        date : "July 15th-19th 2018",
        pdf : "./papers/2018_gecco_ant_colony.pdf"
    },

    {
        authors : "Travis Desell",
        title : "Accelerating the Evolution of Convolutional Neural Networks with Node-Level Mutations and Epigenetic Weight Initialization",
        venue : "The 2018 Genetic and Evolutionary Computation Conference (GECCO 2018) - Evolutionary Machine Learning Poster Session",
        location : "Kyoto, Japan",
        date : "July 15th-19th 2018",
        pdf : "./papers/2018_gecco_exact.pdf"
    },

    {
        authors : "Travis Desell",
        title : "Developing a Volunteer Computing Project to Evolve Convolutional Neural Networks and Their Hyperparameters",
        venue : "The 13th IEEE International Conference on eScience (eScience 2017)",
        location : "Auckland, New Zealand",
        date : "October 24-27 2017",
        pdf : "./papers/2017_escience_exact.pdf"
    },

    {
        authors : "Connor Bowley, Marshall Mattingly III, Andrew Barnas, Susan Ellis-Felege and Travis Desell",
        title : "Toward Using Citizen Scientists to Drive Automated Ecological Object Detection in Aerial Imagery",
        venue : "The 13th IEEE International Conference on eScience (eScience 2017)",
        location : "Auckland, New Zealand",
        date : "October 24-27 2017",
        pdf : "./papers/2017_escience_wildlife.pdf",
    },

    {
        authors : "Travis Desell",
        title : "Large Scale Evolution of Convolutional Neural Networks Using Volunteer Computing",
        venue : "The 2017 Genetic and Evolutionary Computation Conference (GECCO) - Evolutionary Machine Learning Poster Session",
        location : "Berlin, Germany",
        date : "July 15th-19th 2017",
        pdf : "./papers/2017_gecco_exact_2page.pdf"
    },

    {
        authors : "AbdElRahman ElSaid, Fatima ElJamiy, James Higgins, Brandon Wild, Travis Desell",
        title : "Optimizing LSTM Recurrent Neural Networks Using Ant Colony Optimization to Predict Aircraft Engine Vibration",
        venue : "The 2017 Genetic and Evolutionary Computation Conference (GECCO) - Late Breaking Abstracts",
        location : "Berlin, Germany",
        date : "July 15th-19th 2017",
        pdf : "./papers/2017-gecco-lstm.pdf"
    },

    {
        authors : "Marshall Mattingly III, Andrew Barnas, Susan Ellis-Felege, Robert Newman, David Iles and Travis Desell",
        title : "Developing a Citizen Science Web Portal for Manual and Automated Ecological Image Detection",
        venue : "The IEEE 12th International Conference on eScience (eScience 2016)",
        location : "Baltimore, MD, USA",
        date : "October 23-27, 2016",
        pdf : "./papers/2016_escience_images.pdf",
        note : "<b>Best of Conference Award</b>"
    },

    {
        authors : "Connor Bowley, Alicia Andes, Susan Ellis-Felege and Travis Desell",
        title : "Detecting Wildlife in Uncontrolled Outdoor Video using Convolutional Neural Networks",
        venue : "The IEEE 12th International Conference on eScience (eScience 2016)",
        location : "Baltimore, MD, USA",
        date : "October 23-27, 2016",
        pdf : "./papers/2016_escience_cnn.pdf"
    },

    {
        authors : "AbdElRahman ElSaid, Brandon Wild, James Higgins and Travis Desell",
        title : "Using LSTM Recurrent Neural Networks to Predict Excess Vibration Events in Aircraft Engines",
        venue : "The IEEE 12th International Conference on eScience (eScience 2016)",
        location : "Baltimore, MD, USA",
        date : "October 23-27, 2016",
        pdf : "./papers/2016_escience_vibration.pdf"
    },

    {
        authors : "David Apostal, Sara Faraji Jalal Apostal, Ronald Marsh and Travis Desell",
        title : "Towards Modeling a Complex Geological Simulation",
        venue : "The 2016 Spring Simulation Multi-Conference (SpringSim 2016)",
        location : "Pasadena, California, USA",
        date : "April 3-6, 2016",
        pdf : "./papers/2016_springsim.pdf"
    },

    {
        authors : "Travis Desell and Carlos A. Varela",
        title : "Performance and Scalability Analysis of Actor Message Passing and Migration in SALSA Lite",
        venue : "The 5th International Workshop on Programming based on Actors, Agents, and Decentralized Control (AGERE!}, held in conjunction with ACM SIGPLAN conference on Systems, Programming, Languages and Applications: Software for Humanity (SPLASH)",
        location : "Pittsburgh, Pennslyvania, USA",
        date : "October 26th, 2015",
        pdf : "./papers/2015_agere_salsa.pdf"
    },

    {
        authors : "Kyle Goehner, Rebecca Eckroad, Leila Mohsenian, Paul Burr, Nicholas Caswell, Alicia Andes, Susan Ellis-Felege, and Travis Desell",
        title : "A Comparison of Background Subtraction Algorithms for Detecting Avian Nesting Events in Uncontrolled Outdoor Video",
        venue : "The 11th IEEE International Conference on eScience (eScience 2015)",
        location : "Munich, Germany",
        date : "August 31 - September 4, 2015",
        pdf : "./papers/2015_escience_wildlife.pdf",
        note : "<a href='http://csgrid.org/csg/wildlife/data_releases.php'>[Data Release and Supplementary Material]</a>"
    },

    {
        authors : "Kris Zarns, Archana Dhasarathy, Sergei Nechaev and Travis Desell",
        title : "Searching the Human Genome for Snail and Slug With DNA@Home",
        venue : "The 11th IEEE International Conference on eScience (eScience 2015)",
        location : "Munich, Germany",
        date : "August 31 - September 4, 2015",
        pdf : "./papers/2015_escience_dna.pdf"
    },

    {
        authors : "Thomas O'Neil and Travis Desell",
        title : "Empirical Support for the High-Density Subset Sum Decision Threshold",
        venue : "In the 14th IEEE Canadian Workshop on Information Theory (CWIT'15)",
        location : "St. John's, Newfoundland, Canada",
        date : "July 6-9, 2015",
        pdf : "./papers/2015_cwit_sssathome.pdf",
        note : "(Copyright IEEE 2015)"
    },

    {
        authors : "Travis Desell, Kyle Goehner, Alicia Andes, Rebecca Eckroad, and Susan Ellis-Felege",
        title : "On the Effectiveness of Crowd Sourcing Avian Nesting Video Analysis at Wildlife@Home",
        venue : "In the 15th International Conference on Computational Science",
        location : "Reykjavík, Iceland",
        date : "June 1-3, 2015",
        pdf : "./papers/2015_iccs_wildlife.pdf"
    },

    {
        authors : "Travis Desell, Sophine Clachar, James Higgins and Brandon Wild",
        title : "Evolving Deep Recurrent Neural Networks Using Ant Colony Optimization",
        venue : "In the 15th European Conference on Evolutionary Computation in Combinatorial Optimisation (Evo* 2015: EvoCOP)",
        location : "Copenhagen, Denmark",
        date : "April 8-10, 2015",
        pdf : "./papers/2015_evocop.pdf",
        note : "<a href='./ngafid_releases.php'>[Data Release and Supplementary Material]</a>."
    },

    {
        authors : "Travis Desell, Sophine Clachar, James Higgins and Brandon Wild",
        title : "Evolving Neural Network Weights for Time-Series Prediction of General Aviation Flight Data",
        venue : "In the 13th International Conference on Parallel Problem Solving from Nature (PPSN 2014)",
        location : "Ljubljana, Slovenia",
        date : "September 13-17, 2014",
        pdf : "./papers/2014_ppsn.pdf",
        note : "<a href='./ngafid_releases.php'>[Data Release and Supplementary Material]</a>"
    },

    {
        authors : "David Apostal, Kyle Foerster, Travis Desell and Will Gosnold",
        title : "Performance Improvements for a Large-Scale Geological Simulation",
        venue : "In the 14th International Conference on Computational Science (ICCS 2014)",
        location : "Cairns, Australia",
        date : "June 10-12, 2014",
    },

    {
        authors : "Travis Desell, Robert Bergman, Kyle Goehner, Ronald Marsh, Rebecca VanderClute, and Susan Ellis-Felege",
        pdf : "./papers/2013_escience_wildlife.pdf",
        title : "Wildlife@Home: Combining Crowd Sourcing and Volunteer Computing to Analyze Avian Nesting Video",
        venue : "In the 2013 IEEE 9th International Conference on e-Science",
        location : "Beijing, China",
        date : "October 23-25, 2013",
    },

    {
        authors : "Travis Desell",
        pdf : "./papers/2013_ipdps_edupar.pdf",
        title : "Using Actors and the SALSA Programming Language to Introduce Concurrency in Computer Science II",
        venue : "In the Third NSF/TCPP Workshop on Parallel and Distributed Computing Education (EduPar-13}, held in conjunction with the 27th IEEE International Parallel & Distributed Processing Symposium",
        location : "Boston, Massachussets",
        date : "May 20, 2013"
    },

    {
        authors : "David Apostal, Kyle Foerster, Amrita Chatterjee and Travis Desell",
        pdf : "./papers/2012_hipc.pdf",
        title : "Password Recovery Using MPI and CUDA",
        venue : "In the 19th Annual International Conference on High Performance Computing",
        location : "Pune, India",
        date : "December 18-21, 2012"
    },

    {
        authors : "Travis Desell, Malik Magdon-Ismail, Heidi Newberg, Lee Newberg, Boleslaw K. Szymanski, and Carlos A. Varela",
        pdf : "./papers/2011_cise.pdf",
        title : "A Robust Asynchronous Newton Method for Massive Scale Computing Systems",
        venue : "In the 2011 IEEE International Conference on Computational Intelligence and Software Engineering (CiSE 2011)",
        location : "Wuhan, China",
        date : "December 9-11, 2011"
    },

    {
        authors : "Travis Desell, Lee A. Newberg, Malik Magdon-Ismail, Boleslaw K. Szymanski and William Thompson",
        pdf : "./papers/2011_cacs.pdf",
        title : "Finding Protein Binding Sites Using Volunteer Computing Grids",
        venue : "In the 2011 2nd International Congress on Computer Applications and Computational Science (CACS 2011)",
        location : "Bali, Indonesia",
        date : "November 15-17, 2011"
    },

    {
        authors : "Travis Desell, Benjamin A. Willet, Matthew Arsenault, Heidi Newberg, Malik Magdon-Ismail, Boleslaw Szymanski and Carlos A. Varela",
        pdf : "./papers/2011_pcgrid.pdf",
        title : "Evolving N-Body Simulations to Determine the Origin and Structure of the Milky Way Galaxy's Halo using Volunteer Computing",
        venue : "In the Proceedings of the IPDPS'11 Fifth Workshop on Desktop Grids and Volunteer Computing Systems (PCGrid 2011)",
        location : "Anchorage, Alaska, USA",
        date : "May 20, 2011"
    },

    {
        authors : "Travis Desell, David P. Anderson, Malik Magdon-Ismail, Heidi Newberg, Boleslaw Szymanski and Carlos A. Varela",
        pdf : "./papers/2010_cec.pdf",
        title : "An Analysis of Massively Distributed Evolutionary Algorithms",
        venue : "In the Proceedings of the 2010 IEEE Congress on Evolutionary Computation (IEEE CEC 2010)",
        location : "Barcelona, Spain",
        pages : "pages 1-8",
        date : "July 2010"
    },

    {
        authors : "Travis Desell, Malik Magdon-Ismail, Boleslaw Szymanski, Carlos A. Varela, Heidi Newberg and David P. Anderson",
        pdf : "http://milkyway.cs.rpi.edu/milkyway/download/desell_dais_2010.pdf",
        title : "Validating Evolutionary Algorithms on Volunteer Computing Grids",
        venue : "In the Proceedings of the 10th IFIP International Conference on Distributed Applications and Interoperable Systems (DAIS 2010)",
        location : "Amsterdam, Netherlands",
        pages : "pages 29-41",
        date : "June 2010"
    },

    {
        authors : "Travis Desell, Malik Magdon-Ismail, Boleslaw Szymanski, Carlos Varela, Heidi Newberg and Nathan Cole",
        pdf : "http://wcl.cs.rpi.edu/papers/escience2009.pdf",
        title : "Robust Asynchronous Optimization for Volunteer Computing Grids",
        venue : "In the Proceedings of the 5th IEEE International Conference on e-Science (eScience2009)",
        location : "Oxford, UK",
        pages : "pages 263-270",
        date : "December 2009"
    },

    {
        authors : "Nathan Colen, Heidi Newberg, Malik Magdon-Ismail, Travis Desell, Kristopher Dawsey, Warren Hayashi, Xinyang Fred Liu, Jonathan Purnell, Boleslaw Szymanski, Carlos Varela, Benjamin Willett and James Wisniewski",
        title : "A Study of the Sagittarius Tidal Stream Using Maximum Likelihood",
        venue : "In the Proceedings of the 18th Annual Conference on Astronomical Data Analysis Software and Systems",
        location : "Quebec City, Quebec, Canada",
        date : "November 2009"
    },

    {
        authors : "Travis Desell, Anthony Waters, Malik Magdon-Ismail, Boleslaw Szymanski, Carlos Varela, Matthew Newby, Heidi Newberg, Andreas Przystawik and Dave Anderson",
        pdf : "http://wcl.cs.rpi.edu/papers/ppam2009.pdf",
        title : "Accelerating the MilkyWay@Home volunteer computing project with GPUs",
        venue : "In the 8th International Conference on Parallel Processing and Applied Mathematics (PPAM 2009)",
        location : "Wroclaw, Poland",
        date : "September 2009"
    },

    {
        authors : "Nathan Cole, Heidi Newberg, Malik Magdon-Ismail, Travis Desell, Boleslaw Szymanski, Carlos Varela",
        title : "Tracing the Sagittarius Tidal Stream with Maximum Likelihood",
        venue : "In the Proceedings of the International Conference on Classification and Discovery in Large Astronomical Surveys",
        location : "Ringberg Castle, Germany",
        pages : "pages 216-220",
        date : "October 2008"
    },

    {
        authors : "Travis Desell, Boleslaw Szymanski, and Carlos A. Varela.",
        pdf : "http://wcl.cs.rpi.edu/papers/desell-gecco-2008.pdf",
        title : "An Asynchronous Hybrid Genetic-Simplex Search for Modeling the Milky Way Galaxy using Volunteer Computing",
        venue : "In the Proceedings of the Genetic and Evolutionary Computation Conference (GECCO 2008)",
        location : "Atlanta, Georgia",
        pages : "pages 921-928",
        date : "July 2008"
    },

    {
        authors : "Travis Desell, Boleslaw Szymanski, and Carlos A. Varela",
        pdf : "http://wcl.cs.rpi.edu/papers/desell-ags-hcw-2008.pdf",
        title : "Asynchronous Genetic Search for Scientific Modeling on Large-Scale Heterogeneous Environments",
        venue : "In the Proceedings of the 17th International Heterogeneity in Computing Workshop (HCW/IPDPS'08). IEEE",
        location : "Miami, FL",
        pages : "pages 12",
        date : "April 2008"
    },

    {
        authors : "Boleslaw Szymanski, Travis Desell, and Carlos A. Varela",
        pdf : "http://wcl.cs.rpi.edu/papers/ppam07.pdf",
        title : "The Effect of Heterogeneity on Asynchronous Panmictic Genetic Search",
        venue : "In the Proceedings of the 7th International Conference on Parallel Processing and Applied Mathematics (PPAM'2007). LNCS",
        location : "Gdansk, Poland",
        date : "September 2007"
    },

    {
        authors : "Travis Desell, Nathan Cole, Malik Magdon-Ismail, Heidi Newberg, Boleslaw Szymanski, and Carlos A. Varela",
        pdf : "http://wcl.cs.rpi.edu/papers/e-science2007.pdf",
        title : "Distributed and Generic Maximum Likelihood Evaluation",
        venue : "In the Proceedings of the 3rd IEEE International Conference on e-Science and Grid Computing (eScience2007)",
        location : "Bangalore, India",
        pages : "pages 337-344",
        date : "December 2007",
        note : "Best paper finalist"
    },

    {
        authors : "Kaoutar El Maghraoui, Travis Desell, Boleslaw K. Szymanski, and Carlos A. Varela",
        pdf : "http://wcl.cs.rpi.edu/papers/ccgrid07.pdf",
        title : "Dynamic Malleability in Iterative MPI Applications",
        venue : "In the Proceedings of 7th IEEE International Symposium on Cluster Computing and the Grid (CCGrid 2007)",
        location : "Rio de Janeiro, Brazil",
        pages : "pages 591-598",
        date : "May 2007",
        note : "Best paper award nominee"
    },

    {
        authors : "Travis Desell, Kaoutar El Maghraoui, and Carlos A. Varela",
        pdf : "http://wcl.cs.rpi.edu/papers/hpcgeco06.pdf",
        title : "Malleable Components for Scalable High Performance Computing",
        venue : "In the Proceedings of the HPDC'15 Workshop on HPC Grid programming Environments and Components (HPC-GECO/CompFrame). IEEE",
        location : "Paris, France",
        pages : "pages 37-44",
        date : "June 2006",
        note : "Best paper award"
    },

    {
        authors : "Travis Desell, Harihar N. Iyer, Abe Stephens, and Carlos A. Varela",
        pdf : "http://wcl.cs.rpi.edu/papers/etaps2004.pdf",
        title : "OverView: A Framework for Generic Online Visualization of Distributed Systems",
        venue : "In the Proceedings of the European Joint Conferences on Theory and Practice of Software (ETAPS 2004}, eclipse Technology eXchange (eTX) Workshop",
        location : "Barcelona, Spain",
        date : "March 2004"
    },

    {
        authors : "Travis Desell, Kaoutar El Maghraoui, and Carlos A. Varela",
        pdf : "http://wcl.cs.rpi.edu/papers/desel04.pdf",
        title : "Load Balancing of Autonomous Actors over Dynamic Networks",
        venue : "In the Proceedings of the Hawaii International Conference on System Sciences, HICSS-37 Software Technology Track",
        pages : "pages 1-10",
        date : "January 2004"
    }
];
//End Conference Proceedings section

export const technicalReports = [
    {
        authors : "Carlos A. Varela, Gul Agha, Wei-Jen Wang, Travis Desell, Kaoutar El Maghraoui, Jason LaPorte, and Abe Stephens",
        pdf : "http://www.cs.rpi.edu/research/pdf/07-12.pdf",
        title : "The SALSA Programming Language: 1.1.2 Release Tutorial",
        venue : "Technical report 07-12",
        location : "Department of Computer Science, RPI, Troy, NY, USA",
        date : "February 2007"
    },

    {
        authors : "Kaoutar El Maghraoui, Travis J. Desell, and Carlos A. Varela",
        pdf : "http://www.cs.rpi.edu/research/pdf/05-03.pdf",
        title : "Network Sensitive Reconfiguration of Distributed Applications",
        venue : "Technical report 05-03",
        location : "Department of Computer Science, RPI, Troy, NY USA",
        date : "2005"
    },

    {
        authors : "Harihar N. Iyer, Abe Stephens, Travis Desell, and Carlos A. Varela",
        pdf : "http://wcl.cs.rpi.edu/papers/overview2003.pdf",
        title : "OverView - Dynamic Visualization of Java-Based Highly Reconfigurable Distributed Systems",
        venue : "Technical report",
        location : "Worldwide Computing Laboratory, RPI, Troy, NY USA",
        date : "August 2003"
    }
];
//End Internal Reports Section

export const publicTalks = [
    {
        authors : "Travis Desell",
        title : "Efficient Neuroevolution using Island Repopulation and Simplex Hyperparameter Optimization",
        venue : "The 2023 IEEE Symposium Series on Computational Intelligence (SSCI 2023).",
        location : "Mexico City, Mexico",
        date : "December 8, 2023",
        pdf : "./talks/2023-12-08-ssci-island-sho.pdf"
    },

    {
        authors : "Travis Desell",
        title : "Co-evolving Recurrent Neural Networks and their Hyperparameters with Simplex Hyperparameter Optimization",
        venue : "The 2023 Genetic and Evolutionary Computation Conference (GECCO 2023).",
        location : "Lisbon, Portugal",
        date : "July 13, 2023",
        pdf : "./talks/2023-07-13_gecco_sho_workshop.pdf"
    },


    {
        authors : "Travis Desell",
        title : "Investigating Recurrent Neural Network Memory Structures using Neuro-Evolution",
        venue : "The 2019 Genetic and Evolutionary Computation Conference (GECCO 2019).",
        location : "Prague, Czech Republic",
        date : "July 15, 2019",
        pdf : "./talks/2019_07_15_gecco.pdf"
    },

    {
        authors : "Travis Desell",
        title : "Evolving Recurrent Neural Networks for Time Series Data Prediction of Coal Plant Parameters ",
        venue : "The 22nd International Conference on the Applications of Evolutionary Computation  (EvoStar: EvoApps 2019)",
        location : "Leipzig, Germany",
        date : "April 24, 2019",
        pdf : "./talks/2019_04_24_evostar_leipzig.pdf"
    },

    {
        authors : 'Travis Desell',
        title : 'Investigating Recurrent Neural Network Memory Structures using Neuro-Evolution',
        venue : 'RIT CHAI AI Seminar and RIT GCCIS PhD Research Colloquium in Computing and Information Sciences',
        pages : '',
        location : 'Rochester Institute of Technology, Rochester, NY',
        date : 'February 9 and February 11, 2019',
        note : '',
        pdf : './talks/2019_02_11_chai.pdf'
    },

    {
        authors : 'Travis Desell',
        title : 'Wildlife@Home',
        venue : 'South Big Data Hub VITAL Data Series - Video Data Analysis',
        pages : '',
        location : 'Online - Hosted by Georgia Tech',
        date : 'October 27, 2015',
        note : '',
        pdf : './talks/2016_october_27_gatech_vital_big_data.pdf'
    },

    {
        authors : 'Travis Desell',
        title : 'Lightning Talk - Digital Agriculture - Unmanned Aircraft Systems, Plant Sciences and Education',
        venue : 'The 12th IEEE International Conference on eScience (eScience 2015)',
        pages : '',
        location : 'Baltimore, Maryland',
        date : 'October 25, 2015',
        note : '',
        pdf : './talks/2016_escience_digital_ag_lightning_talk.pdf'
    },

    {
        authors : 'Travis Desell',
        title : 'Using LSTM Recurrent Neural Networks to Predict Excess Vibration Events in Aircraft Engines',
        venue : 'The 12th IEEE International Conference on eScience (eScience 2015)',
        pages : '',
        location : 'Baltimore, Maryland',
        date : 'October 25, 2015',
        note : '',
        pdf : './talks/2016_escience_lstm.pdf'
    },

    {
        authors : 'Travis Desell',
        title : 'Developing a Citizen Science Web Portal for Manual and Automated Ecological Image Detection',
        venue : 'The 12th IEEE International Conference on eScience (eScience 2015)',
        pages : '',
        location : 'Baltimore, Maryland',
        date : 'October 25, 2015',
        note : '',
        pdf : './talks/2016_escience_marshall_images.pdf'
    },

    {
        authors : 'Travis Desell',
        title : 'A Comparison of Background Subtraction Algorithms for Detecting Avian Nesting Events in Uncontrolled Outdoor Video',
        venue : 'The 11th IEEE International Conference on eScience (eScience 2015)',
        pages : '',
        location : 'Munich, Germany',
        date : 'September 1, 2015',
        note : '',
        pdf : './talks/2015_september_1_eScience_wildlife.pdf'
    },

    {
        authors : 'Travis Desell',
        title : 'On the Effectiveness of Crowd Sourcing Avian Nesting Video Analysis at Wildlife@Home ',
        venue : 'In the 15th International Conference on Computational Science',
        pages : '',
        location : 'Reykjavik, Iceland',
        date : 'June 3, 2015',
        note : '',
        pdf : './talks/2015_june_3_iccs.pdf'
    },

    {
        authors : 'Travis Desell',
        title : 'Evolving Deep Recurrent Neural Networks Using Ant Colony Optimization',
        venue : 'The 15th European Conference on Evolutionary Computation in Combinatorial Optimization',
        pages : '',
        location : 'Copenhagen, Denmark',
        date : 'April 9, 2015',
        note : '',
        pdf : './talks/2015_april_evostar.pdf'
    },

    {
        authors : 'Travis Desell',
        title : 'Citizen Science at the University of North Dakota',
        venue : 'Biology Department Seminar',
        pages : '',
        location : 'Grand Forks, North Dakota',
        date : 'March 6, 2015',
        note : '',
        pdf : './talks/2015_mar_6_und_citizen_science.pdf'
    },

    {
        authors : 'Travis Desell',
        title : 'MilkyWay@Home',
        venue : '',
        pages : '',
        location : 'Arizona State University, Tempe, AZ',
        date : 'November 8, 2013',
        note : '',
        html : './talks/2013_nov_8_spacevision/index.html',
    },

    {
        authors : 'Travis Desell',
        title : "Wildlife@Home: Combining Crowd Sourcing and Volunteer Computing to Analyze Avian Nesting Video",
        html : "./talks/2013_october_23_escience/index.html",
        venue : "The 9th International Conference on E-Science (e-Science 2013)",
        location : "Beijing, China",
        date : "October 23, 2013"
    },

    {
        authors : 'Travis Desell',
        title : "Crowd Sourcing Big Data",
        venue : "Digital Lightning, 'TED' Style Talks hosted by UND's Digital and New Media Working Group",
        location : "University of North Dakota, Grand Forks, ND",
        date : "April 22, 2013"
    },

    {
        authors : 'Travis Desell',
        title : "FOQA in University Flight Operations",
        venue : "Aviation Safety InfoShare",
        location : "Denver, CO",
        date : "March 20, 2013"
    },

    {
        authors : 'Travis Desell',
        title : "DNA@Home: Using Volunteered Computers for Finding Transcription Factor Binding Sites",
        ppt : "./talks/2012_nov_15_und_epigenetics.ppt",
        keynote : "./talks/2012_nov_15_und_epigenetics.key",
        venue : "UND Epigenetics and Epigenomics Symposium",
        location : "University of North Dakota, Grand Forks, ND",
        date : "November 15, 2012"
    },

    {
        authors : 'Travis Desell',
        title : "Wildlife@Home",
        ppt : "./talks/2012_boinc_workshop.ppt.zip",
        keynote : "./talks/2012_boinc_workshop.key",
        venue : "The 8th International BOINC Workshop",
        location : "University of Westminster, London, UK",
        date : "September 27, 2012"
    },

    {
        authors : 'Travis Desell',
        title : "Wildlife@Home",
        ppt : "./talks/2012_und_digital_media_showcase.ppt.zip",
        keynote : "./talks/2012_und_digital_media_showcase.key",
        venue : "The UND Digital Media Showcase",
        location : "Fire Hall Theatre, Grand Forks, North Dakota, USA",
        date : "April 11, 2012"
    },

    {
        authors : 'Travis Desell',
        title : "Asynchronous Methods for Scalable and Robust Numerical Optimization",
        ppt : "./talks/2012_ibm_research.ppt.zip",
        keynote : "./talks/2012_ibm_research.key",
        venue : "Invited Talk",
        location : "IBM T.J. Watson Research Center, Yorktown, New York, USA",
        date : "April 5, 2012"
    },

    {
        authors : 'Travis Desell',
        title : "Finding Protein Binding Sites using Volunteer Computing Grids",
        ppt : "./talks/2011_nov_15_cacs.ppt",
        keynote : "./talks/2011_nov_15_cacs.key",
        venue : "The 2011 2nd International Congress on Computer Applications and Computational Science (CACS 2011)",
        location : "Bali, Indonesia",
        date : "November 15-17, 2011"
    },

    {
        authors : 'Travis Desell',
        title : "From Analyzing the Tuberculosis Genome to Modeling the Milky Way Galaxy: Using Volunteer Computing for Computational Science",
        ppt : "http://milkyway.cs.rpi.edu/milkyway/download/desell_und_2010.ppt",
        keynote : "http://milkyway.cs.rpi.edu/milkyway/download/desell_und_2010.key",
        venue : "Public Talk",
        location : "University of North Dakota, Grand Forks, North Dakota, USA",
        date : "November 2010"
    },

    {
        authors : 'Travis Desell',
        title : "MilkyWay@Home and Volunteer Computing at RPI",
        ppt : "http://milkyway.cs.rpi.edu/milkyway/download/2010_4_23_RPI_rcos.ppt",
        keynote : "http://milkyway.cs.rpi.edu/milkyway/download/2010_4_23_RPI_rcos.key",
        venue : "Invited Talk",
        location : "RPI Center for Open Source Software (RCOSS}, Troy, New York, USA",
        date : "April 2010"
    },

    {
        authors : 'Travis Desell',
        title : "Asynchronous Global Optimization for Massive-Scale Computing",
        ppt : "http://milkyway.cs.rpi.edu/milkyway/download/travis_phd_defense.ppt",
        keynote : "http://milkyway.cs.rpi.edu/milkyway/download/travis_phd_defense.key",
        venue : "PhD Defense",
        location : "RPI, Troy, New York, USA",
        date : "November 2009"
    },

    {
        authors : 'Travis Desell',
        title : "Robust Asynchronous Optimization using Volunteer Computing Grids",
        ppt : "http://milkyway.cs.rpi.edu/milkyway/download/boinc2009.ppt",
        keynote : "http://milkyway.cs.rpi.edu/milkyway/download/boinc2009.key",
        venue : "The 5th Annual Pan-Galactic BOINC Workshop",
        location : "Barcelona, Spain",
        date : "October 2009"
    },

    {
        authors : 'Travis Desell',
        title : "An Asynchronous Hybrid Genetic-Simplex Search for Modeling the Milky Way Galaxy Using Volunteer Computing",
        venue : "Genetic and Evolutionary Computation Conference (GECCO 2008)",
        location : "Atlanta, Georgia, USA",
        date : "July 2008"
    },

    {
        authors : 'Travis Desell',
        title : "Scientific Discovery Through Computationally Intensive Maximum Likelihood Evaluation",
        venue : "NSF Symposium on Cyber-Enabled Discovery and Innovation (NSF-CDI 2007)",
        location : "Troy, New York, USA",
        date : "September 2007"
    },

    {
        authors : 'Travis Desell',
        title : "Malleable Components for Scalable High Performance Computing",
        venue : "Workshop on HPC Grid Programming Environments and Components (HPC-GECO/CompFrame)",
        location : "Paris, France",
        date : "June 2006"
    },

    {
        authors : 'Travis Desell',
        title : "OverView: A Framework for Generic Online Visualization of Distributed Systems",
        venue : "European Joint Conferences on Theory and Practice of Software (ETAPS 2004}, eclipse Technology eXchange (eTX) workshop",
        location : "Barcelona, Spain",
        date : "March 2004"
    }
];
//End public talks section

export const press = [
    {
        title : "Volunteers Create a 'Web' of Power",
        date : "June 18, 2012",
        links : [
            {
                href : "http://webapp.und.edu/dept/our/discovery/volunteers-create-a-web-of-power",
                link : "UND Discovery"
            }
        ]
    },
    {
        title : "PCs Around the World Unite To Map the Milky Way",
        date : "February 10, 2010",
        links : [
            {
                href : "http://news.rpi.edu:80/update.do?artcenterkey=2685",
                link : "RPI News"
            },
            {
                href : "http://www.sciencedaily.com/releases/2010/02/100210124823.htm",
                link : "Science Daily"
            }
        ]
    }
];
//end press section

const PaperRow = ({paperInfo}) => {
    let authors = ('authors' in paperInfo) ? (<>{paperInfo.authors}.</>) : "";
    let venue = ('venue' in paperInfo) ? (<><i>{paperInfo.venue}</i>.</>) : "";
    let pages = ('pages' in paperInfo) ? (<>{paperInfo.pages + "."}</>) : "";
    let location = ('location' in paperInfo) ? (<>{paperInfo.location}.</>) : "";
    let publisher = ('publisher' in paperInfo) ? (<>{paperInfo.publisher + "."}</>) : "";
    let date = ('date' in paperInfo) ? (<>{paperInfo.date + "."}</>) : "";
    let note = ('note' in paperInfo) ? (<><b>{paperInfo.note}</b>.</>) : "";

    let pdf = ('pdf' in paperInfo) ? (<a href={paperInfo.pdf}>[pdf]</a>) : "";
    let ppt = ('ppt' in paperInfo) ? (<a href={paperInfo.ppt}>[ppt]</a>) : "";
    let keynote = ('keynote' in paperInfo) ? (<a href={paperInfo.keynote}>[keynote]</a>) : "";
    let html = ('html' in paperInfo) ? (<a href={paperInfo.html}>[html]</a>) : "";

    /*
        {{#links}}
        <a href='{{href}}'>[{{link}}]</a>
        {{/links}}
        */

    return (
        <li> {authors} <b>{paperInfo.title}</b>. {venue} {pages} {location} {publisher} {date} {note} {pdf} {ppt} {keynote} {html} </li>
    );
}

const StudentPapersSection = ({studentName}) => {
    let papers = [];

    console.log("studentName: '" + studentName + "'");
    let studentNames = studentName.split(" ");
    console.log("studentName.split: " + studentNames);
    let lastName = studentNames[studentNames.length - 1];
    console.log("student last name is: '" + lastName + "'");

    const appendPapers = (paperList) => {
        console.log("appending papers from: " + paperList);

        for (const paperInfo of paperList) {
            console.log("checking paper with authors: '" + paperInfo.authors + "'");
            if (paperInfo.authors.includes(lastName)) {
                papers.push(paperInfo);
                console.log("appending paper with authors: " + paperInfo.authors);
            }
        }
    };

    appendPapers(conferencePapers);
    appendPapers(journals);
    appendPapers(preprints);
    appendPapers(theses);
    appendPapers(bookChapters);
    appendPapers(technicalReports);
    appendPapers(publicTalks);

    const paperRows = papers.map((paperInfo, paperIndex) => {
            return ( <PaperRow paperInfo={paperInfo}></PaperRow> );
        }
    );

    console.log("papers.length: " + papers.length);

    if (papers.length > 0) {
        return (
            <>
                <br/>
                <b>Publications:</b>
                <ol>
                    {paperRows}
                </ol>
            </>
        );
    } else {
        return "";
    }
}

const PapersSection = ({sectionTitle, sectionRef, papers}) => {

    const paperRows = papers.map((paperInfo, paperIndex) => {
            if (paperInfo.not_mine) {
                return "";
            } else {
                return ( <PaperRow paperInfo={paperInfo}></PaperRow> );
            }
        }
    );

    return (
        <>
            <Card className="mt-3 mb-3">
                <Card.Header as="h5" ref={sectionRef}>{sectionTitle}</Card.Header>
                <Card.Body>
                    <ol>
                    {paperRows}
                    </ol>
                </Card.Body>
            </Card>
        </>
    );
}



const Publications = () => {
    let [selectedNav, setSelectedNav] = useState("Conference Proceedings");

    const conferenceRef = useRef(null);
    const journalRef = useRef(null);
    const preprintRef = useRef(null);
    const thesesRef = useRef(null);
    const chapterRef = useRef(null);
    const booksRef = useRef(null);
    const technicalRef = useRef(null);
    const talksRef = useRef(null);

    const updateSelectedNav = (newSelect: string):void => {
        console.log("new nav selection is: '" + newSelect + "'");
        setSelectedNav(newSelect);

        if (newSelect === "Conference Proceedings") {
            conferenceRef.current.scrollIntoView();
        } else if (newSelect === "Journal Articles") {
            journalRef.current.scrollIntoView();
        } else if (newSelect === "Preprints") {
            preprintRef.current.scrollIntoView();
        } else if (newSelect === "Theses") {
            thesesRef.current.scrollIntoView();
        } else if (newSelect === "Book Chapters") {
            chapterRef.current.scrollIntoView();
        } else if (newSelect === "Books") {
            booksRef.current.scrollIntoView();
        } else if (newSelect === "Technical Reports") {
            technicalRef.current.scrollIntoView();
        } else if (newSelect === "Public Talks") {
            talksRef.current.scrollIntoView();
        }
    }


    return (
        <>
            <Nav className="justify-content-center" activeKey={selectedNav} onSelect={(selectedKey) => updateSelectedNav(selectedKey)}>
                <Nav.Item>
                    <Nav.Link eventKey="Conference Proceedings">Conference Proceedings</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="Journal Articles">Journal Articles</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="Preprints">Preprints</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="Theses">Theses</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="Book Chapters">Book Chapters</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="Books">Books</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="Technical Reports">Technical Reports</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="Public Talks">Public Talks</Nav.Link>
                </Nav.Item>
            </Nav>

            <PapersSection sectionTitle="Conference Proceedings" sectionRef={conferenceRef} papers={conferencePapers}></PapersSection>
            <PapersSection sectionTitle="Journal Articles" sectionRef={journalRef} papers={journals}></PapersSection>
            <PapersSection sectionTitle="Preprints" sectionRef={preprintRef} papers={preprints}></PapersSection>
            <PapersSection sectionTitle="Theses" sectionRef={thesesRef} papers={theses}></PapersSection>
            <PapersSection sectionTitle="Book Chapters" sectionRef={chapterRef} papers={bookChapters}></PapersSection>
            <PapersSection sectionTitle="Books" sectionRef={booksRef} papers={books}></PapersSection>
            <PapersSection sectionTitle="Technical Reports" sectionRef={technicalRef} papers={technicalReports}></PapersSection>
            <PapersSection sectionTitle="Public Talks" sectionRef={talksRef} papers={publicTalks}></PapersSection>
        </>
    );

};

export {StudentPapersSection, Publications};
